import { useContext, useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import BoxGames from "./BoxGames";
import Arenas from "./Arenas";
import { useGetAllCampaigns } from "../../api/campaigns/getAllCampaigns";
import { useGetBrands } from "../../api/brands/getBrands";
import { UserContext } from "../context/UseContext";
import { CardLoader } from "../loader/CardLoader";
import { CustomLoader } from "../loader/customLoader";
import clsx from "clsx";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
    partialVisibilityGutter: 20,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    partialVisibilityGutter: 20,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 20,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
    partialVisibilityGutter: 20,
  },
};

const bgs = [
  {
    bg: "linear-gradient(215.13deg, #FF0084 -3.92%, #AF0014 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #00B3FF -3.92%, #0040AF 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #75AF00 95.77%)",
  },
  {
    bg: "linear-gradient(215.13deg, #FFBB2A -3.92%, #E28605 95.77%)",
  },
];

function HomeUI({ category }) {
  const { token } = useContext(UserContext);
  const { getCampaigns, campaigns, loading } = useGetAllCampaigns();
  const { getBrands, brands, loading: loadingBrands } = useGetBrands();
  const hasFetchedBrands = useRef(false);

  useEffect(() => {
    getCampaigns(token, "", category);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  useEffect(() => {
    if (hasFetchedBrands.current) return;
    hasFetchedBrands.current = true;
    getBrands(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div>
        <h4 className="text-xl px-4 font-bold">Popular Campaigns</h4>
        <p className="text-sm text-[#00000080] font-semibold px-4">
          Get ready to win exciting rewards.
        </p>
        {loading ? (
          <CardLoader />
        ) : campaigns.length === 0 ? (
          <div className="flex justify-center items-center h-[33vh] flex-col gap-2">
            <p className="tracking-tighter text-xl font-semibold text-black mx-0 text-center">
              🎮 No games found
            </p>
            <p className="text-sm font-medium mt-1 text-black w-full max-w-[300px] text-center">
              Try exploring another category or check back later for new games.
            </p>
          </div>
        ) : (
          <Carousel
            autoPlay={false}
            responsive={responsive}
            arrows={false}
            partialVisible={true}
            ssr={true}
            infinite={campaigns.length > 2 ? true : false}
            className={clsx(campaigns.length === 1 && "!-ml-0", "mt-5 -ml-10")}
          >
            {campaigns?.map((x, i) => (
              <BoxGames x={x} key={i} />
            ))}
          </Carousel>
        )}
        {/* <>
        <h4 className="text-xl px-4 font-bold">Recommended Campaigns</h4>
        <p className="text-sm text-[#00000080] font-semibold px-4">
          Get ready to win exciting rewards.
        </p>
        {loading ? (
          <CardLoader />
        ) : (
          <Carousel
            autoPlay={false}
            responsive={responsive}
            arrows={false}
            partialVisible={true}
            ssr={true}
            className="mt-5  -ml-10"
          >
            {campaigns?.map((x, i) => (
              <BoxGames x={x} key={i} />
            ))}
          </Carousel>
        )}
        </> */}
        <h4 className="text-xl px-4 font-bold">Discover more arenas</h4>
        <p className="text-sm text-[#00000080] font-semibold px-4">
          Get ready to win exciting rewards.
        </p>
        <div className="mt-5 grid grid-cols-12 gap-4 mb-10 px-4">
          {loadingBrands
            ? Array.from({ length: 2 }).map((_, i) => (
                <div
                  key={i}
                  className="rounded-2xl hover:scale-95 col-span-6 p-2.5"
                >
                  <CustomLoader className="!rounded-2xl !h-[120px]" />
                </div>
              ))
            : brands.map((x, i) => {
                return <Arenas key={i} x={x} bg={bgs[i % bgs.length].bg} index={i} />;
              })}
        </div>
      </div>
    </div>
  );
}

export default HomeUI;
